<template>
  <Modal
    v-bind="$attrs"
    title="Informações"
    :titleIcons="titleIcons"
    :hasActions="false"
    :width="computedWidth"
    @close="$emit('close')"
  >
    <div v-if="!!cliente">
      <template v-if="cliente">
        <CardTitle title="Cliente" class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <p class="font-weight-bold mb-0">{{ cliente.nome_fantasia }}</p>
          </div>
        </CardTitle>
        <CardTitle title="Configurações" class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <span>Limite Crédito</span>
            <p class="font-weight-bold mb-0">{{ cliente.limite_credito || 0 | price }}</p>
          </div>
          <div class="d-flex justify-space-between align-center">
            <span>Tabela Preço</span>
            <p class="font-weight-bold mb-0">{{ cliente.tabela_preco || 'Nenhuma' }}</p>
          </div>
          <div class="d-flex justify-space-between align-center">
            <span>Condição Pagamento</span>
            <p class="font-weight-bold mb-0">{{ cliente.condicao_pagamento || 'Nenhuma' }}</p>
          </div>
        </CardTitle>
        <CardTitle title="Financeiro">
          <Menu
            slot="actions"
            :items="financeiroItems"
            @atualizaInfoFinanceiro="$emit('atualizaFinanceiroCliente')"
          />
          <template v-if="cliente.financeiro">
            <div class="d-flex justify-space-between align-center">
              <span>Total em Atraso</span>
              <p class="font-weight-bold mb-0 red--text">{{ cliente.financeiro.Total || 0 | price }}</p>
            </div>
            <div class="d-flex justify-space-between align-center">
              <span>Qtde em Atraso</span>
              <p class="font-weight-bold mb-0">{{ cliente.financeiro.Quantidade || 'Nenhum' }}</p>
            </div>
            <!-- <div class="d-flex justify-space-between align-center">
              <span>Último Vencimento</span>
              <p class="font-weight-bold mb-0">{{ ultimoVencimentoCliente }}</p>
            </div> -->
          </template>
          <div v-else>
            Nenhum registro encontrado
          </div>
        </CardTitle>
      </template>
      <Alert
        v-else
        type="error"
        text="Não foi possível obter informações"
        :alertClass="$vuetify.breakpoint.xs ? 'caption my-3' : 'my-3'"
      />
    </div>
    <PageLoading v-else />
  </Modal>
</template>

<script>
export default {
  name: 'ModalInfoCliente',
  props: {
    cliente: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal: () => import('@/components/shared/Modal'),
    Alert: () => import('@/components/shared/Alert'),
    CardTitle: () => import('@/components/shared/CardTitle'),
    Menu: () => import('@/components/shared/Menu'),
  },
  data: () => ({
    titleIcons: [
      {
        name: 'mdi-close',
        event: 'close',
        loading: false
      }
    ],
    financeiroItems: [
      { title: 'Atualizar', value: 'atualizaInfoFinanceiro' },
    ]
  }),
  computed: {
    // ultimoVencimentoCliente() {
    //   if (this.cliente.financeiro) {
    //     const vencimento = this.cliente.financeiro.UltimoVencimento;

    //     return vencimento === '1899-12-30' ? 'Nenhum' : this.$options.filters.dateMonthYear(vencimento);
    //   }

    //   return 'Nenhum';
    // },
    computedWidth() {
      const breakpoint = this.$vuetify.breakpoint;
      
      if (breakpoint.xs) return '300px';
      if (breakpoint.sm) return '500px';
      if (breakpoint.md) return '500px';
      if (breakpoint.lg) return '500px';
      if (breakpoint.xl) return '500px';

      return '300px';
    },
    enderecoCliente() {
      const endereco = this.cliente.enderecos[0];

      const text =
        `${endereco.logradouro} ${endereco.numero} ${endereco.complemento} ${endereco.ponto_referencia} 
        ${endereco.bairro} ${endereco.cidade} ${endereco.cep}`;
      
      return text;
    },
  },
}
</script>

<style>

</style>